<template>
  <div class="index_title_img">
    <div class="page-head-title-img"></div>
  </div>
</template>

<script>
export default {
  name: "Title"
}
</script>

<style lang="scss">
.index_title_img {
  text-align: center;
  margin-top: -22px;

  .png_title {
    width: 300px;
    z-index: 1;
  }
}
</style>
